function Socials() {
  return (
    <div className="socials">
      <a
        href="https://open.spotify.com/artist/5I9IfHBhWQTfHsrX8dHPAc"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/socialsIcons/Spotify_Primary_Logo_RGB_Green.png"
          alt="Spotify"
        />
      </a>
      <a
        href="https://music.apple.com/gb/artist/pomona-park/1625147191"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/Apple_Music_icon.svg.png" alt="Apple Music" />
      </a>
      <a
        href="https://www.instagram.com/pomona.park/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/IG.png" alt="Instagram" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCYjnfqdxp5hVtPQWuv-aiAw"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/youtube.png" alt="X / Twitter" />
      </a>
      <a
        href="https://www.facebook.com/PomonaParkOfficial"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/facebook.png" alt="Facebook" />
      </a>
      <a
        href="https://twitter.com/Pomona_Park"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/x.png" alt="X / Twitter" />
      </a>
      <a
        href="https://www.tiktok.com/@pomona.park.official"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="/socialsIcons/tiktok.png" alt="X / Twitter" />
      </a>
    </div>
  );
}

export default Socials;
